import useExecuteQuery from "hooks/useExecuteQuery";

import { GET_SETTINGS_TSL_SUGGESTS } from "graphqlQueries/suggests";
import { getSuggests } from "graphqlQueries/suggests.map";

export default function useSettingsTlsSuggests() {
  const { data, loading } = useExecuteQuery(GET_SETTINGS_TSL_SUGGESTS, {
    dataMapper: getSuggests,
  });

  return { loading, ...data };
}
